import { LicenseMonthlyAddonsFormWebComponent } from './component/LicenseMonthlyAddonsFormWebComponent';
import { WEB_COMPONENT_LICENSE_MONTHLY_ADDONS_FORM } from '../../../webcomponents.constants';

export { LicenseMonthlyAddonsFormWebComponent };

window.customElements.define(WEB_COMPONENT_LICENSE_MONTHLY_ADDONS_FORM, LicenseMonthlyAddonsFormWebComponent);
